import React, { useEffect, useState } from "react";
import "../style/Ricarica.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { useSelector, useDispatch } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SwiperCore, { Pagination } from "swiper/core";
import "swiper/components/pagination/pagination.min.css";
import md5 from "md5";
import MemoryIcon from "@mui/icons-material/Memory";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router";
import ConfermaBTN from "../components/ConfermaBTN/ConfermaBTN";
import { setIdContratto, setPayMethodDefault } from "../features/userSlice";
import NewHeader from "../components/New Header/NewHeader";
// install Swiper modules
SwiperCore.use([Pagination]);

function Ricarica() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerId = useSelector((user) => user.user.info.customer_id);
  const customerIdGas = useSelector((user) => user?.gas?.info?.customer_id);
  const userName = useSelector((user) => user.user.info.customer_full_heading);
  const [cards, setCards] = useState(null);
  const [taglia, setTaglia] = useState(null);
  const [value, setValue] = useState(null);
  const [bonus, setBonus] = useState(null);
  const saldo = useSelector((user) => user.user.currentBalanceEnrica);
  const saldoGas = useSelector((user) => user.gas.saldo);
  const iban = useSelector((user) => user.user.datiPagamento.account_iban)
  const token = useSelector((user) => user.user.datiPagamento.token);
  const tokenGas = useSelector((user) => user?.gas?.datiPagamento?.token);
  const ibanGas = useSelector((user) => user?.gas?.datiPagamento?.account_iban);
  const tkn = md5(customerId + "oYmAIdtki%lu");
  const tknGas = md5(`${customerIdGas}oYmAIdtki%lu`);
  const apiSaveCard = `https://my.revoluce.it/area_utente/gestione/api/payments/pay.php?amount=${value}&token=${token}&customer_id=${customerId}&tkn_pvt=${tkn}`;
  const apiSaveCardGas = `https://my.revoluce.it/area_utente/gestione/api/payments/pay.php?amount=${value}&token=${tokenGas}&customer_id=${customerIdGas}&tkn_pvt=${tknGas}`;
  const section = useSelector((user) => user.settings.section);
  const datiPagamentoGas = useSelector((user) => user?.gas?.datiPagamento);
  const idContratto = useSelector((user) => user.user.idContratto);
  const notifiche = useSelector((user) => user.user.notifiche);
  const allNotifiche = notifiche && [...notifiche[0], ...notifiche[1]];
  const importoIncassoProgrammato = allNotifiche.map((r) => r.importo);

  useEffect(() => {
    init();
    getMethod();
    getBonus();
  }, []);

  const init = async () => {
    const apiCard = `https://my.revoluce.it/area_utente/gestione/api/customers/getCarte.php?customer_id=${
      section ? customerIdGas : customerId
    }&tkn_pvt=${section ? tknGas : tkn}`;
    const { data } = await axios.get(apiCard);
    console.log(section)
    // setCards(data)
  };
  const getBonus = async () => {
    const getBonus = `https://my.revoluce.it/area_utente/gestione/api/movements/getBonus.php?customer_id=${
      section ? customerIdGas : customerId
    }&tkn_pvt=${section ? tknGas : tkn}`;
    const res = await axios.get(getBonus);
    setBonus(res.data.totale_bonus);
  };
  const getMethod = async () => {
    const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${
      section ? customerIdGas : customerId
    }&tkn_pvt=${section ? tknGas : tkn}`;
    const { data } = await axios.get(apiMethod);
    dispatch(setPayMethodDefault(data.dati.metodo_predefinito));
    setCards(data.dati.dati_token);
    dispatch(setIdContratto(data.dati.id_contratto));
  };
  const setTagliaAndValue = (e) => {
    if (e.target.name === "uno") {
      setTaglia(1);
      setValue(parseInt(e.target.value));
    } else if (e.target.name === "due") {
      setTaglia(2);
      setValue(parseInt(e.target.value));
    } else if (e.target.name === "tree") {
      setTaglia(3);
      setValue(parseInt(e.target.value));
    } else {
      setTaglia(0);
      setValue(parseFloat(e.target.value).toFixed(2));
    }
  };
  const setCustomValue = (e) => {
    setTaglia(4);
    setValue(e.target.value.replace(/\,/g, "."));
  };
  // const ricarica = async () => {
  //     setLoading(true)
  //     if(isNumber(value)){
  //         await axios.get(apiSaveCard).then(({ data }) => {
  //             if(data.success) {
  //                 setTaglia(null);
  //                 setValue(null)
  //                 setTimeout(() => {
  //                     window.location.reload()
  //                 },3000)
  //             } else {
  //                 alert('Qualcosa è andato storto, riprova.')
  //                 setLoading(false)
  //             }
  //         })
  //     } else {
  //         alert('Importo inserito non valido')
  //         setLoading(false)
  //     }

  // }

  const usaBonus = async () => {
    const useBonus = `https://my.revoluce.it/area_utente/gestione/api/movements/setBonus.php?customer_id=${customerId}&tkn_pvt=${tkn}`;
    const res = await axios.get(useBonus);
    if (res.data.success === true) {
      navigate("/enrica/richiesta-inoltrata");
    } else {
      alert(
        "Abbiamo riscontrato un errore, ti preghiamo di contattare il servizio clienti."
      );
    }
  };
  const setUnique = async (id) => {
    const methodUrl = `https://my.revoluce.it/area_utente/gestione/api/faidate/setMetodoPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}&id_metodo=20&id_contratto=${idContratto}&id_token=${id}`;
    const { data } = await axios.get(methodUrl);
    init();
  };
  const goBack = () => {
    navigate(-1);
  };
  console.log('--->', iban, token)
  return (
    <div className="ricarica">
      <div className="ricarica-top">
        <NewHeader
          setOverlay={goBack}
          overlay={true}
          padding="no"
          overlayTitle="Indietro"
          iconsColor="white"
        />
      </div>
      <div className="ricarica-bottom">
        <div className="cards">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            grabCursor={true}
            pagination={true}
          >
            {cards && !section ? (
              cards.map((r) => (
                <SwiperSlide>
                  <div className="metodo">
                    <div
                      className={
                        r.token_default === "1" ? "card primary" : "card"
                      }
                    >
                      <div className="card_top">
                        <MemoryIcon />
                        <div className="primaryContainer">
                          {r.token_default === "1" ? (
                            <p>Predefinita</p>
                          ) : (
                            <p
                              onClick={() => setUnique(r.id)}
                              style={{ textDecoration: "underline" }}
                            >
                              Imposta come predefinita
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="card_body">
                        <p>
                          **** **** **** {r.token.slice(r.token.length - 4)}
                        </p>
                      </div>
                      <div className="card_bottom">
                        <p>{userName}</p>
                        <div className="expiry">
                          <p className="label">SCADENZA</p>
                          <p>
                            {r.token_month}/{r.token_year}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))
            ) : datiPagamentoGas !== null &&
              datiPagamentoGas.method_name === "RID" ? (
              <SwiperSlide>
                <div className="metodo iban">
                  <div className="card primary">
                    <div className="card_top">
                      <MemoryIcon />
                    </div>
                    <div className="card_body">
                      <p className="label">IBAN:</p>
                      <p>
                        **** **** ****{" "}
                        {ibanGas && ibanGas.slice(ibanGas.length - 4)}
                      </p>
                    </div>
                    <div className="card_bottom">
                      <p>{userName}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ) : cards && section ? (
              cards.map((r) => (
                <SwiperSlide>
                  <div className="metodo">
                    <div
                      className={
                        r.token_default === "1" ? "card primary" : "card"
                      }
                    >
                      <div className="card_top">
                        <MemoryIcon />
                        <div className="primaryContainer">
                          {r.token_default === "1" ? (
                            <p>Predefinita</p>
                          ) : (
                            <p
                              onClick={() => setUnique(r.id)}
                              style={{ textDecoration: "underline" }}
                            >
                              Imposta come predefinita
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="card_body">
                        <p>
                          **** **** **** {r.token.slice(r.token.length - 4)}
                        </p>
                      </div>
                      <div className="card_bottom">
                        <p>{userName}</p>
                        <div className="expiry">
                          <p className="label">SCADENZA</p>
                          <p>
                            {r.token_month}/{r.token_year}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))
            ) : null}

            <SwiperSlide onClick={() => navigate("/enrica/profilo/aggiungi")}>
              <div className="metodo add">
                <p>
                  <AddIcon /> Aggiungi metodo di pagamento
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="scorriLabel">
            <p>
              Scrorri per cambiare o aggiungere un nuovo metodo di pagamento
            </p>
          </div>
        </div>
        {!section && iban === null && token === null ||
        section && ibanGas === null && tokenGas === null ? (
          <>
            <p className="warningMessage">
              <span className="bold">Attenzione:</span> non hai nessuna carta di
              pagamento registrata e per questo non puoi effettuare ricariche.
              Registra subito una carta per accedere a questa funzionalità.
            </p>
            <a
              className="warningMessage"
              onClick={() => navigate("/enrica/profilo/aggiungi")}
            >
              Registra una carta
            </a>
          </>
        ) : (
          <>
            <div className="packs">
              {section ? (
                <div className="pack fromEnrica">
                  <p>Azzera il saldo</p>
                  <button
                    name="custom"
                    value={
                      saldoGas !== null
                        ? parseFloat(saldoGas.toFixed(2).replace("-", ""))
                        : "0"
                    }
                    className={taglia === 0 ? "active" : null}
                    onClick={(e) => setTagliaAndValue(e)}
                  >
                    {saldoGas !== null
                      ? saldoGas.toFixed(2).replace(/\./g, ",").replace("-", "")
                      : "0"}
                    <span className="currency">€</span>
                  </button>
                </div>
              ) : saldo > 0 ? null : (
                <div className="pack fromEnrica">
                  <p>Azzera il saldo</p>
                  <button
                    name="custom"
                    value={
                      saldo !== null
                        ? parseFloat(saldo.toFixed(2).replace("-", ""))
                        : "0"
                    }
                    className={taglia === 0 ? "active" : null}
                    onClick={(e) => setTagliaAndValue(e)}
                  >
                    {saldo !== null
                      ? saldo.toFixed(2).replace(/\./g, ",").replace("-", "")
                      : "0"}
                    <span className="currency">€</span>
                  </button>
                </div>
              )}
              <div className="pack taglie">
                <p>Scegli un taglio</p>
                <div className="flexRow">
                  <div className="taglia_uno">
                    <button
                      value="25"
                      name="uno"
                      className={taglia === 1 ? "active" : null}
                      onClick={(e) => setTagliaAndValue(e)}
                    >
                      25<span className="currency">€</span>
                    </button>
                  </div>
                  <div className="taglia_due">
                    <button
                      value="50"
                      name="due"
                      className={taglia === 2 ? "active" : null}
                      onClick={(e) => setTagliaAndValue(e)}
                    >
                      50<span className="currency">€</span>
                    </button>
                  </div>
                  <div className="taglia_tre">
                    <button
                      value="100"
                      name="tree"
                      className={taglia === 3 ? "active" : null}
                      onClick={(e) => setTagliaAndValue(e)}
                    >
                      100<span className="currency">€</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="addCustom">
              <div className="label">
                <p>Inserisci l'importo da ricaricare</p>
              </div>

              <div className="input">
                <input
                  type="text"
                  placeholder="Es. 10.00"
                  onClick={() => setTaglia(4)}
                  className={taglia === 4 ? "active" : null}
                  onChange={(e) => setCustomValue(e)}
                />
              </div>
            </div>

            <ConfermaBTN
              disableAdd={value ? false : true}
              forward="/enrica/ricarica-confermata"
              url={section ? apiSaveCardGas : apiSaveCard}
              text="Conferma ricarica"
              confermTxt={
                notifiche[0].length > 0
                  ? `Abbiamo già programmato un incasso di ${
                      importoIncassoProgrammato && importoIncassoProgrammato
                    }€ su ****${
                      token && token.slice(token.length - 4)
                    }, vuoi comunque prcedere con la ricarica di ${value}€ ?`
                  : notifiche[1].length > 0
                  ? `Abbiamo già programmato un incasso su ****${
                      token && token.slice(token.length - 4)
                    } vuoi comunque prcedere con la ricarica di ${value}€ ?`
                  : `Vuoi ricaricare ${value}€ dalla carta ****${
                      token && token.slice(token.length - 4)
                    } ?`
              }
            />
            {/* <SwiperButton url={section ? apiSaveCardGas : apiSaveCard} amount={value} forward={'/enrica/ricarica-confermata'}/> */}
          </>
        )}

        {/* <div className="conferma">
                    <button disabled={value === null ? null : value.length === 0 ? true : false} onClick={() => ricarica()}>{loading ? <CircularProgress /> : 'Conferma ricarica'}</button>
                </div> */}
        {section ? null : bonus === null ? null : (
          <div className="bonusContainer">
            <p className="h2">
              Hai accumulato un bonus pari a{" "}
              <span className={bonus >= 10 ? "green" : "red"}>
                {parseFloat(bonus).toFixed(2).replace(/\./g, ",")} €
              </span>
            </p>
            {bonus >= 10 ? (
              <p className="paragraph">
                Utilizza subito il tuo bonus ricaricando il tuo conto.
              </p>
            ) : (
              <p className="paragraph">
                {" "}
                Ti mancano ancora{" "}
                {parseFloat(Math.abs(bonus - 10))
                  .toFixed(2)
                  .replace(/\./g, ",")}{" "}
                € per usufruire del bonus.
              </p>
            )}
            <div className="button">
              <button
                onClick={() => usaBonus()}
                disabled={bonus >= 10 ? false : true}
              >
                Utilizza il bonus <ChevronRightIcon />{" "}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Ricarica;
